<template>
  <div
    v-if="!isCTA"
    class="articles__item"
    :class="{ 'articles__item--20321B': showNewSaveDesign }"
  >
    <template v-if="showNewSaveDesign && view.hasUserData(doc)">
      <SaveButton class="articles__save-button" :doc="doc" :docsView="view" />
      <DocMoreMenu class="articles__more-menu" :doc="doc" :docsView="view" />
    </template>
    <router-link :to="view.startLinkParams(doc)" class="articles__link">
      <div class="articles__img-box">
        <DocTypeBadge v-if="showNewSaveDesign" docType="article" />
        <div v-else-if="doc.has_audio" class="articles__play">
          <span class="articles__play-icon iconfont iaudio"></span>
        </div>
        <!-- crossorigin is needed to set request.mode="cors" , without which the
          serviceworker will see an opaque response which is dangerous to cache.
          See: #7397

          Any changes to this attribute should be kept in sync with the book
          card, and also the preload code in `_loadImagesForDocs` in the
          model.
        -->
        <LazyImage
          :src="doc.cover_thumbnail"
          crossorigin="anonymous"
          class="articles__img"
          alt=""
        />
      </div>
      <div class="articles__text-box">
        <div class="articles__text">
          <h5
            v-if="!showNewSaveDesign"
            class="articles__category card__category"
          >
            {{ view.firstTag(doc) }}
          </h5>
          <h3 class="articles__title card__title">
            {{ doc.title }}
          </h3>
          <h4 class="articles__author card__author">
            {{ showNewSaveDesign ? doc.author : `By ${doc.author}` }}
          </h4>
        </div>
        <div class="articles__bottom-box">
          <DocBadges v-if="showNewSaveDesign" :doc="doc" />
          <template v-else>
            <TimeEstimate :doc="doc" />
            <FavoriteFlag
              v-if="view.hasUserData(doc)"
              class="articles__collection collection"
              :doc="doc"
              :docsView="view"
            />
          </template>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { ArticlesView } from '@/models/doc.article'
import type { ArticleListItem } from '@/models/interfaces'

import DocBadges from '@/app/components/doc/DocBadges.vue'
import DocMoreMenu from '@/app/components/doc/DocMoreMenu.vue'
import DocTypeBadge from '@/app/components/doc/DocTypeBadge.vue'
import SaveButton from '@/app/components/doc/SaveButton.vue'
import TimeEstimate from '@/app/components/doc/TimeEstimate.vue'
import FavoriteFlag from '@/app/components/listing/FavoriteFlag.vue'
import LazyImage from '@/app/components/podcast/card/LazyImage.vue'
import { saveForLater20321Treatment } from '@/services/ab/experiments'

const props = defineProps<{
  view: ArticlesView
  doc: ArticleListItem
}>()

const showNewSaveDesign = saveForLater20321Treatment()

const isCTA = computed(() => {
  return props.doc.title === 'CTA'
})
</script>

<style lang="scss" scoped>
.articles {
  &__link {
    display: flex;
    flex-direction: inherit;
    flex-grow: 1;
  }

  &__save-button {
    position: absolute;
    z-index: 2;
    top: 12px;
    right: 12px;
  }

  &__more-menu {
    position: absolute;
    z-index: 2;
    right: 19px;
    bottom: 18px;

    // Line up with the Save button and the badges.
    @media (max-width: $w-tablet-s) {
      right: 12px;
      bottom: 14px;
    }

    @media (max-width: $w-mobile-s) {
      bottom: 6px;
    }
  }

  &__item--20321B {
    position: relative;

    // Match the width of the book card's cover column on mobile.
    .docs-listing__list & .articles__img-box {
      @media (max-width: $w-tablet-s) {
        width: 122px;
      }
    }

    .articles__text {
      @media (max-width: $w-tablet-s) {
        padding-right: 32px;
      }
    }
  }
}
</style>
